<app-header [ngClass]="{fixedHeader: headerClass === true}"></app-header>

<!-- content -->
<section class="fullscreen home-block main-effect" style="position: relative;" (window:scroll)="doSomethingOnInternalScroll($event)">
    <!-- start-section -->
    <div class="home-block__start-section" id="effectCanvas" style="background-image:url('./assets/img/home/bkg.jpg')">
        <div class="bgImage-mobile"></div>
        <div class="content start-section">
            <div class="column-12">
                <p class="start-section__subtitle start-section__subtitle--top">Adictos a</p>
                <h1 class="text-h1 text-h1--start-section">
                    New Sexy
                    <span class="txt-rotate"
                        data-period="2000"
                        data-rotate='[ "Digital", "Services", "Experiences", "Business", "Products" ]'>
                    </span>
                </h1>
                <p class="start-section__subtitle start-section__subtitle--bottom">Que hacemos con mucha empatía, sentido común y foco en los resultados</p>
            </div>
        </div>
    </div>
    <div class="bubble-red" [ngClass]="bubbleRed ? 'bubble--expanseRed' : ' '">
        <span (click)="bubbleRedExpanse()">
            <svg class="cross" width="32" height="32" viewBox="0 0 32 32">
                <g fill="none" fill-rule="evenodd">
                    <g fill="#FFF">
                        <g>
                            <g>
                                <path d="M25.333 8.547L23.453 6.667 16 14.12 8.547 6.667 6.667 8.547 14.12 16 6.667 23.453 8.547 25.333 16 17.88 23.453 25.333 25.333 23.453 17.88 16z" transform="translate(-1367 -783) translate(1082 644) translate(285 139)"/>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <svg class="arrow" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                    <g fill="#FFF">
                        <g>
                            <g>
                                <path d="M19 2.82L16.146 0 4 12 16.146 24 19 21.18 9.729 12z" transform="translate(-1399 -908) translate(1367 872) translate(32 36)"/>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </span>
        <p>Somos muy de compartir</p>
        <a href="https://readymag.com/u1154665407/contenidoboost/" target="_blank">Recursos útiles<br/> y creativos</a>
    </div>

    <!-- what-do -->
    <div class="home-block__what-do" id="what-do">
        <div class="content what-do">
            <div class="what-do__column">
                <span class="index">01</span>
                <h2 class="text-h2">Qué hacemos</h2>
                <p>
                    En un entorno cambiante y complejo, lo que queremos es ponerlo fácil. Simplificar el escenario y <strong> crear productos, servicios y experiencias de valor,</strong> a través del <strong>diseño estratégico.</strong>
                </p>
                <p>
                    Por ir simplificando desde ya, esto es entender las necesidades de los usuarios, los objetivos de negocio y las oportunidades del mercado, para ofrecer la <strong>mejor solución.</strong>
                </p>
                <p>
                    Y lo hacemos a través de <strong>los modelos y metodologías de hoy.</strong> Porque hemos comprobado que se consiguen soluciones realmente diferenciales, y de manera más ágil.
                </p>
            </div>
            <div class="what-do__undertext">
                <h2 class="text-h2 text-h2--what-do">Designing Great Experiences</h2>
            </div>
        </div>
    </div>

    <!-- services -->
    <div class="home-block__services" id="services">
        <div class="content services">
            <div class="column-4">
                <div class="services__fact services__fact--left">
                    <img class="services__img" alt="Conceptualizamos" src="./assets/img/home/services/icon-concept.svg">
                    <h3 class="text-h3">
                        Conceptualizamos
                    </h3>
                    <p class="fact__detail">
                        Primero, investigamos y empatizamos. Con los insights obtenidos pasamos a los retos y de ahí, a la generación de ideas, que prototipamos y diseñamos.
                    </p>
                    <p >
                        <strong>Design Research | Product design | Service Design</strong>
                    </p>
                </div>
            </div>
            <div class="column-4">
                <div class="services__fact">
                    <img class="services__img" alt="Construimos" src="./assets/img/home/services/icon-build.svg">
                    <h3 class="text-h3">
                        Construimos
                    </h3>
                    <p class="fact__detail">
                        Implementamos las ideas. Desarrollamos, testeamos e iteramos, buscando mejorar siempre. Y estamos al lado de los usuarios en la adopción de nuevos productos.
                    </p>
                    <p>
                        <strong>Cross-technology | Any technology</strong>
                    </p>
                </div>
            </div>
            <div class="column-4">
                <div class="services__fact services__fact--right">
                    <img class="services__img" alt="Difundimos" src="./assets/img/home/services/icon-spread.svg">
                    <h3 class="text-h3">
                        Difundimos
                    </h3>
                    <p class="fact__detail">
                        Si no se cuenta, no existe. Ayudamos a nuestros clientes a conseguir KPIs a través de estrategias de marketing y comunicación, poniendo el contenido en el centro.
                    </p>
                    <p ><strong>In-company | To the world</strong></p>
                </div>
            </div>
        </div>
        <div>
            <h2 class="text-h2 text-h2--services">Servicios</h2>
        </div>
    </div>

        <!-- product -->
        <div class="home-block__products" id="productsd">
            <div class="poducts-content">
                <div class="column-12 team__sub-block produtText">
                    <span class="index">02</span>
                    <h2 class="text-h2">PRODUCTOS DIGITALES</h2>
                    <p>
                        Normalmente creamos productos ad hoc, pero a veces imaginamos productos útiles sin que haya 
                        una petición formal de un cliente. Nuestro LAB de creación y desarrollo se dedica a crear <span>soluciones digitales</span> que dan respuesta a temas de hoy y que están desarrollados mimando al máximo la experiencia, el diseño y el rendimiento de los mismos. Si alguno te interesa, pregúntanos. Y si no, también, 
                        porque tenemos otros tantos en el horno :)
                    </p>
                </div>
                <div class="column-12 team__sub-block produtCards">
                    <div onclick="" class="produtCard produtCard--01">
                        <div class="imgBox">
                            <img src="./assets/img/home/product/img-card-wow.png">
                            <div class="circle-log circle-log--01">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#FFF">
                                            <g>
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path d="M30 0v15c0 8.284-6.716 15-15 15C6.82 30 .17 23.453.003 15.314L0 15V0h30zm-.905.905H.905V15.91l.03.001C1.402 23.27 7.52 29.095 15 29.095c7.479 0 13.597-5.825 14.066-13.185h.029V.904z" transform="translate(-233 -2717) translate(0 2120) translate(194 369) translate(24 213) translate(15 15)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                        <div class="title">
                            <p><span>W</span>ow</p>
                        </div>
                        <div class="hoverContent">
                            <div class="title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
                                    <g fill="none" fill-rule="evenodd">
                                        <g>
                                            <g>
                                                <g>
                                                    <g>
                                                        <path fill="#000" fill-rule="nonzero" d="M31.424 49L38.016 29.896 44.576 49 47.072 49 54.624 26.6 52.352 26.6 45.792 45.96 39.2 26.6 36.992 26.6 30.304 45.864 23.84 26.6 21.408 26.6 28.96 49z" transform="translate(-315 -2583) translate(195 2545) translate(88 38) translate(32)"/>
                                                        <g fill="#E11E6C">
                                                            <path d="M76 0v38c0 20.987-17.013 38-38 38C17.223 76 .34 59.325.005 38.628L0 38V0h76zm-2.293 2.293H2.293v38.01h.073C3.554 58.952 19.054 73.708 38 73.708S72.446 58.95 73.634 40.304h.073V2.294z" transform="translate(-315 -2583) translate(195 2545) translate(88 38) translate(32)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                <p><span>W</span>ow</p>
                            </div>
                            <p class="text-info">
                                Solución para el desarrollo y gestión de los flujos de trabajo de cualquier organización.
                            </p>
                            <a href="https://wow.digboost.com/" target="_blank" class="hrefBtn">Descubre más</a>
                        </div>
                    </div>
                    <div onclick="" class="produtCard produtCard--02">
                        <div class="imgBox">
                            <img src="./assets/img/home/product/img-card-railway.png">
                            <div class="circle-log circle-log--02">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#FFF">
                                            <g>
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path d="M15 0c8.18 0 14.83 6.547 14.997 14.686L30 15v15H15C6.82 30 .17 23.453.003 15.314L0 15V0h15zm0 .921H.921V15l.003.314C1.092 22.944 7.33 29.08 15 29.08h14.079V15l-.003-.314C28.908 7.056 22.67.92 15 .92z" transform="translate(-602 -2717) translate(0 2120) translate(563 369) translate(24 213) translate(15 15)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                        <div class="title">
                            <p><span>R</span>ailway</p>
                        </div>
                        <div class="hoverContent">
                            <div class="title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
                                    <g fill="none" fill-rule="evenodd">
                                        <g>
                                            <g>
                                                <g>
                                                    <g>
                                                        <path fill="#000" fill-rule="nonzero" d="M32.448 50v-7.104h6.016c.64 0 1.216-.032 1.792-.096l5.12 7.2h2.592l-5.472-7.68c3.264-1.056 5.12-3.52 5.12-7.04 0-4.8-3.456-7.68-9.152-7.68H30.08V50h2.368zm5.952-9.12h-5.952V29.648H38.4c4.48 0 6.848 2.048 6.848 5.632 0 3.52-2.368 5.6-6.848 5.6z" transform="translate(-683 -2582) translate(563 2545) translate(88 37) translate(32)"/>
                                                        <g fill="#56BDCA">
                                                            <path d="M38 0c20.777 0 37.66 16.675 37.995 37.372L76 38v38H38C17.223 76 .34 59.325.005 38.628L0 38V0h38zm0 2.333H2.333V38l.005.59C2.653 58.016 18.498 73.667 38 73.667h35.667V38l-.005-.59C73.347 17.984 57.502 2.333 38 2.333z" transform="translate(-683 -2582) translate(563 2545) translate(88 37) translate(32)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                <p><span>R</span>ailway</p>
                            </div>
                            <p class="text-info">
                                Plataforma para la gestión del plan de carrera de los empleados.
                            </p>
                            <a href="https://railway.digboost.com/" target="_blank" class="hrefBtn">Descubre más</a>
                        </div>
                    </div>
                    <div  onclick="" class="produtCard produtCard--03">
                        <div class="imgBox">
                            <img src="./assets/img/home/product/img-card-bam.png">
                            <div class="circle-log circle-log--03">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#FFF">
                                            <g>
                                                <g>
                                                    <g>
                                                        <path d="M15 0c8.284 0 15 6.716 15 15 0 8.18-6.547 14.83-14.686 14.997h-.084V30H0V15.23h.002L0 15C0 6.82 6.547.17 14.686.003L15 0zm0 .921l-.314.003C7.056 1.092.92 7.33.92 15l.002.216H.921V29.08H15c7.776 0 14.079-6.303 14.079-14.079C29.079 7.224 22.776.921 15 .921z" transform="translate(-972 -2717) translate(933 2489) translate(24 213) translate(15 15)"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                        <div class="title">
                            <p><span>B</span>am</p>
                        </div>
                        <div class="hoverContent">
                            <div class="title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
                                    <g fill="none" fill-rule="evenodd">
                                        <g>
                                            <g>
                                                <g>
                                                    <g>
                                                        <path fill="#000" fill-rule="nonzero" d="M39.388 49c5.6 0 8.416-2.176 8.416-5.984 0-3.04-1.728-4.928-4.608-5.568 2.048-.832 3.424-2.528 3.424-5.088 0-3.648-2.88-5.76-7.872-5.76h-9.664V49h10.304zm-.8-12.32h-7.136v-8.128h7.136c3.584 0 5.664 1.376 5.664 4.064s-2.08 4.064-5.664 4.064zm.768 10.368h-7.904v-8.416h7.904c3.936 0 6.08 1.28 6.08 4.192 0 2.944-2.144 4.224-6.08 4.224z" transform="translate(-1051 -2583) translate(931 2545) translate(88 38) translate(32)"/>
                                                        <g fill="#FCCB44">
                                                            <path d="M38 0c20.987 0 38 17.013 38 38 0 20.777-16.675 37.66-37.372 37.995l-.044-.001V76H0V38.585l.005-.001L0 38C0 17.223 16.675.34 37.372.005L38 0zm0 2.333l-.59.005C17.984 2.653 2.333 18.498 2.333 38l.004.548h-.004v35.119H38.55l-.001-.006h.042c19.23-.31 34.76-15.841 35.072-35.071l.005-.59C73.667 18.302 57.698 2.333 38 2.333z" transform="translate(-1051 -2583) translate(931 2545) translate(88 38) translate(32)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                                <p><span>B</span>am</p>
                            </div>
                            <p class="text-info">
                                Plataforma de contenido interactivo que te permitirá comunicar de una manera distinta.
                            </p>
                            <a [routerLink]="['/contacto-proyecto']" class="hrefBtn">Pregúntanos</a>
                        </div>
                    </div>
                    <div  onclick="" class="produtCard produtCard--04">
                        <div class="imgBox">
                            <img src="./assets/img/home/product/img-card-levelup.png">
                            <div class="circle-log circle-log--04">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#FFF">
                                            <g>
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path d="M15 0c8.18 0 14.83 6.547 14.997 14.686L30 15v15H0V0h15zm0 1.053H1.053v27.894h27.894V15l-.003-.311C28.778 7.129 22.599 1.053 15 1.053z" transform="translate(-233 -3086) translate(0 2120) translate(194 738) translate(24 213) translate(15 15)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                        <div class="title">
                            <p><span>L</span>evelUp</p>
                        </div>
                        <div class="hoverContent">
                            <div class="title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
                                    <g fill="none" fill-rule="evenodd">
                                        <g>
                                            <g>
                                                <g>
                                                    <g>
                                                        <path fill="#000" fill-rule="nonzero" d="M46.636 49L46.636 46.952 34.092 46.952 34.092 26.6 31.724 26.6 31.724 49z" transform="translate(-315 -2951) translate(195 2913) translate(88 38) translate(32)"/>
                                                        <g fill="#6DE0F6">
                                                            <path d="M38 0c20.777 0 37.66 16.675 37.995 37.372L76 38v38H0V0h38zm0 2.667H2.667v70.666h70.666V38l-.004-.584C73.017 18.17 57.319 2.666 38 2.666z" transform="translate(-315 -2951) translate(195 2913) translate(88 38) translate(32)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                                <p><span>L</span>evelUp</p>
                            </div>
                            <p class="text-info">
                                Solución de Reskilling y Upskilling de empleados, basándose en Inteligencia Artificial y la escucha activa.
                            </p>
                            <a [routerLink]="['/contacto-proyecto']" class="hrefBtn">Pregúntanos</a>
                        </div>
                    </div>
                    <div  onclick="" class="produtCard produtCard--05">
                        <div class="imgBox">
                            <img src="./assets/img/home/product/img-card-booker.png">
                            <div class="circle-log circle-log--05">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#FFF">
                                            <g>
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path d="M15 0c8.284 0 15 6.716 15 15 0 8.18-6.547 14.83-14.686 14.997L15 30H0V0h15zm0 1.053H1.053v27.894H15l.311-.003c7.56-.166 13.636-6.345 13.636-13.944 0-7.703-6.244-13.947-13.947-13.947z" transform="translate(-602 -3086) translate(0 2120) translate(563 738) translate(24 213) translate(15 15)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                        <div class="title">
                            <p><span>B</span>ookker</p>
                        </div>
                        <div class="hoverContent">
                            <div class="title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="126" height="35" viewBox="0 0 126 35">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#6F6EDB" fill-rule="nonzero">
                                            <g>
                                                <g>
                                                    <g>
                                                        <path d="M7 38.61c0-.601.776-.839 1.11-.34l3.026 4.525 3.673 5.49c-1.793 1.657-2.868 4.084-2.703 6.759.258 4.152 3.579 7.55 7.708 7.88 5.178.412 9.469-3.89 9.07-9.089-.314-4.116-3.643-7.448-7.742-7.754-1.517-.114-2.955.179-4.222.778l-2.857-4.272c1.975-1.08 4.246-1.68 6.662-1.64 7.09.116 12.963 5.852 13.263 12.968.17 4.05-1.431 7.726-4.088 10.316h.002l-8.984 8.6c-.234.225-.602.225-.837 0l-8.983-8.6C8.573 61.767 7 58.32 7 54.503zm53.854 11.642c.937 0 1.825.184 2.638.549.81.363 1.518.865 2.106 1.49.587.624 1.057 1.362 1.396 2.195.34.835.513 1.735.513 2.677s-.173 1.835-.513 2.654c-.34.816-.81 1.545-1.396 2.169-.588.625-1.298 1.123-2.108 1.478-.812.356-1.7.536-2.636.536-.937 0-1.82-.18-2.623-.536-.802-.355-1.51-.852-2.107-1.477-.595-.624-1.07-1.354-1.409-2.17-.34-.817-.513-1.71-.513-2.654 0-.943.172-1.844.512-2.677s.814-1.572 1.41-2.196c.596-.625 1.304-1.126 2.105-1.489.804-.365 1.687-.55 2.625-.55zm14.961 0c.937 0 1.825.184 2.637.549.81.363 1.519.865 2.107 1.49.587.624 1.057 1.362 1.396 2.195.34.835.512 1.735.512 2.677s-.172 1.835-.513 2.654c-.34.816-.809 1.545-1.395 2.169-.588.625-1.298 1.123-2.109 1.478-.812.356-1.698.536-2.635.536-.937 0-1.82-.18-2.623-.536-.802-.355-1.51-.852-2.107-1.477-.596-.624-1.07-1.354-1.41-2.17-.34-.817-.512-1.71-.512-2.654 0-.943.172-1.844.512-2.677s.814-1.572 1.41-2.196c.596-.625 1.304-1.126 2.104-1.489.805-.365 1.688-.55 2.626-.55zm-34-5.252v6.99c.452-.446.972-.82 1.551-1.112.79-.4 1.661-.602 2.586-.602.92 0 1.79.176 2.586.523.792.345 1.496.828 2.093 1.435.596.607 1.07 1.332 1.411 2.158.341.825.514 1.737.514 2.71 0 .973-.177 1.89-.526 2.723-.349.832-.827 1.565-1.423 2.18-.598.616-1.307 1.103-2.107 1.449-.804.346-1.67.522-2.572.522-.938 0-1.82-.18-2.624-.536-.8-.354-1.51-.845-2.105-1.46-.597-.615-1.071-1.35-1.411-2.182-.34-.831-.513-1.739-.513-2.697V45h2.54zm75.68 5.276c.854 0 1.694.171 2.496.51.802.337 1.524.833 2.147 1.474.62.64 1.12 1.424 1.485 2.329.365.906.55 1.948.55 3.099v.254h-10.658c.078.505.227.966.442 1.374.257.485.58.9.957 1.236.378.336.804.595 1.266.77.461.175.946.264 1.439.264.85 0 1.58-.192 2.169-.57.589-.378 1.052-.918 1.376-1.604l.07-.147h2.74l-.11.334c-.46 1.398-1.24 2.49-2.319 3.243-1.076.752-2.397 1.134-3.926 1.134-.954 0-1.852-.18-2.671-.535-.817-.353-1.537-.84-2.142-1.446-.605-.607-1.089-1.333-1.437-2.157-.349-.825-.526-1.73-.526-2.688 0-.941.177-1.841.526-2.674.348-.832.826-1.565 1.422-2.18.596-.614 1.303-1.11 2.103-1.472.805-.363 1.68-.548 2.601-.548zM87.57 45v10.884l5.44-5.29h3.827l-5.215 5.003 5.508 8.085h-3.164l-4.25-6.26-2.146 2.059v4.201h-2.613V45h2.613zm13.711 0v10.884l5.44-5.29h3.827l-5.215 5.003 5.508 8.085h-3.164l-4.25-6.26-2.146 2.059v4.201h-2.613V45h2.613zm30.619 5.3c.284 0 .578.017.874.051l.227.026v2.436l-.281-.026c-.195-.018-.386-.027-.567-.027-.887 0-1.612.22-2.155.655-.645.517-.972 1.355-.972 2.49v7.777h-2.614v-7.729c0-.975.17-1.848.504-2.594.336-.75.8-1.372 1.379-1.851.578-.478 1.26-.82 2.026-1.016.5-.128 1.032-.193 1.579-.193zm-85.971 2.39c-.551 0-1.075.115-1.557.342-.485.229-.915.546-1.277.943-.365.399-.661.871-.879 1.403-.216.528-.326 1.108-.326 1.723 0 .617.11 1.201.327 1.738.217.539.517 1.019.89 1.426.37.405.804.726 1.29.955.482.226.997.341 1.532.341.551 0 1.074-.115 1.556-.341.486-.23.916-.546 1.278-.943.364-.399.655-.873.864-1.41.21-.538.316-1.132.316-1.766 0-.616-.106-1.202-.316-1.74-.21-.537-.5-1.007-.863-1.397-.362-.39-.793-.703-1.28-.932-.48-.227-1.004-.342-1.555-.342zm14.914.074c-.553 0-1.078.115-1.561.342-.487.228-.918.545-1.282.942-.365.398-.657.873-.867 1.411-.21.537-.317 1.114-.317 1.716 0 .6.106 1.169.316 1.689.21.522.502.985.866 1.375.364.388.794.697 1.28.918.484.22 1.01.331 1.565.331.554 0 1.08-.111 1.564-.33.487-.222.923-.532 1.294-.922.373-.39.667-.851.877-1.372.21-.521.317-1.09.317-1.69 0-.6-.107-1.177-.317-1.715-.21-.537-.506-1.011-.878-1.41-.373-.397-.809-.715-1.296-.943-.483-.227-1.008-.342-1.561-.342zm14.96 0c-.552 0-1.077.115-1.56.342-.487.228-.918.545-1.283.942-.364.398-.656.873-.866 1.411-.21.537-.317 1.114-.317 1.716 0 .6.106 1.169.315 1.689.211.522.502.985.867 1.375.363.388.794.697 1.28.918.484.22 1.01.331 1.565.331.554 0 1.08-.111 1.564-.33.487-.222.923-.532 1.294-.922.372-.39.667-.851.877-1.372.21-.521.316-1.09.316-1.69 0-.6-.106-1.177-.317-1.715-.21-.537-.505-1.011-.878-1.41-.372-.397-.808-.715-1.295-.943-.483-.227-1.009-.342-1.561-.342zm-54.938-4.065c3.239 0 5.864 2.597 5.864 5.801s-2.625 5.801-5.864 5.801S15 57.704 15 54.5s2.625-5.8 5.864-5.8zm96.631 3.967c-.412 0-.827.073-1.234.217-.408.145-.79.357-1.136.631-.349.276-.663.619-.935 1.018-.212.313-.382.663-.504 1.045h7.564c-.12-.357-.28-.693-.478-1.002-.256-.399-.558-.745-.899-1.028-.338-.281-.716-.501-1.123-.653-.406-.151-.828-.228-1.255-.228z" transform="translate(-659 -2941) translate(0 2127) translate(564 738) translate(88 38)"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <p class="text-info">
                                App para la gestión eficaz en remoto de recursos en el lugar de trabajo.
                            </p>
                            <a href="https://bookker.digboost.com/es" target="_blank" class="hrefBtn">Descubre más</a>
                        </div>
                    </div>
                    <!-- <div  onclick="" class="produtCard produtCard--06">
                        <div class="imgBox">
                            <img src="./assets/img/home/product/img-card-sentient.png">
                            <div class="circle-log circle-log--06">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#FFF">
                                            <g>
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path d="M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm0 1.053C7.297 1.053 1.053 7.297 1.053 15c0 7.703 6.244 13.947 13.947 13.947 7.703 0 13.947-6.244 13.947-13.947 0-7.703-6.244-13.947-13.947-13.947z" transform="translate(-970 -3086) translate(0 2120) translate(929 738) translate(26 213) translate(15 15)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                
                            </div>
                        </div>
                        <div class="title">
                            <p><span>S</span>entient</p>
                        </div>
                        <div class="hoverContent">
                            <div class="title">
                                <img src="./assets/img/home/product/sentient-logo-card.png">
                            </div>
                            <p class="text-info">
                                Solución que te permite conocer en tiempo real la experiencia de las personas de tu organización o proyecto.
                            </p>
                            <a href="https://sentient.digboost.com/es" target="_blank" class="hrefBtn">Descubre más</a>
                        </div>
                    </div> -->
                </div>
            </div>
            <span class="text-bg">LA TIENDA</span>
        </div>

    <!-- team -->
    <div class="home-block__team" id="team">
        <div class="content team">
            <div class="column-6 team__sub-block">
                <span class="index">03</span>
                <h2 class="text-h2">EQUIPO</h2>
                <p>
                    Somos muchos. Expertos en service design, product design, user experience, user interface, estrategia, marketing, comunicación… todos con muchas ganas de <strong>romper patrones.</strong>
                </p>
                <p>
                    Y somos muchos más si tenemos en cuenta que formamos parte de Stratesys, con más de 1.000 profesionales que nos aportan un <strong>músculo tecnológico</strong> brutal y un profundo <strong>conocimiento sectorial</strong> de más de 20 años.
                </p>
                <span class="text-detail"> 20 años</span>
            </div>
            <div class="column-6 team__sub-block">
                <div class="team__right-info">
                    <span class="right-info__column1">Expertos</span>
                    <div class="right-info__column2">
                        <p>sectoriales +</p>
                        <p>en tecnología +</p>
                        <p>en diseño estratégico +</p>
                    </div>
                </div>
                <div class="team__quote">
                    <h3 class="text-h3"> = Proyectos memorables que consiguen resultados de negocio</h3>
                </div>
            </div>
        </div>
    </div>

    <!-- methodology -->
    <div class="home-block__methodology" >
        <div class="methodology">
            <h2 class="methodology__text-highlight methodology-animation ">Focused on creativity and agile  ->  Design Thinking, Agile, Scrum</h2>
        </div>
    </div>

    <!-- success -->
    <div class="home-block__success" id="success">
        <div class="content">
            <div class="home-block__title">
                <span class="index">04</span>
                <h2 class="text-h2">Casos de Éxito</h2>
            </div>
        </div>
        <div class="fullscreen--flex">

            <div class="column-4">
                <div onclick="" class="case">
                    <div class="case__info">
                        <h3 class="text-h3 text-h3__success">Digitalización de Procesos</h3>
                        <p class="case__text">Conceptualización y desarrollo de aplicación mobile y desktop para la optimización del flujo de trabajo entre roles</p>
                    </div>
                    <div class="case__img">
                        <img class="case__img" src="./assets/img/home/success/1-repsol.jpg" alt="Digitalización de Procesos">
                    </div>
                </div>
            </div>

            <div class="column-4">
                <div onclick="" class="case">
                    <div class="case__info">
                        <h3 class="text-h3 text-h3__success">Service / Product Design</h3>
                        <p class="case__text">Aplicación web para la mejora del proceso de evaluación del desempeño de empleados</p>
                    </div>
                    <div class="case__img">
                        <img class="case__img" src="./assets/img/home/success/2-loreal.jpg" alt="Service / Product Design">
                    </div>
                </div>
            </div>
            <div class="column-4">
                <div onclick="" class="case">
                    <div class="case__info">
                        <h3 class="text-h3 text-h3__success">Product Design</h3>
                        <p class="case__text">Diseño UX/UI y desarrollo de banca online en base a estudios de usuario y mercado</p>
                    </div>
                    <div class="case__img">
                        <img class="case__img" src="./assets/img/home/success/6-telefonica.jpg" alt="Product Design">
                    </div>
                </div>
            </div>
            <div class="column-4">
                <div onclick="" class="case">
                    <div class="case__info">
                        <h3 class="text-h3 text-h3__success">Innovación</h3>
                        <p class="case__text">Chatbot para facilitar la búsqueda de oportunidades de empleo en la web y la suscripción a comunicaciones</p>
                    </div>
                    <div class="case__img">
                        <img class="case__img" src="./assets/img/home/success/3-inditex.jpg" alt="Innovación">
                    </div>
                </div>
            </div>

            <div class="column-4">
                <div onclick="" class="case">
                    <div class="case__info">
                        <h3 class="text-h3 text-h3__success">Diseño y Contenido Web</h3>
                        <p class="case__text">Generación continua de contenido y diseño UX/UI del portal de profesionales</p>
                    </div>
                    <div class="case__img">
                        <img class="case__img" src="./assets/img/home/success/4-RochePlus.jpg" alt="Diseño y Contenido Web">
                    </div>
                </div>
            </div>
            <div class="column-4">
                <div onclick="" class="case">
                    <div class="case__info">
                        <h3 class="text-h3 text-h3__success">Branding y Comunicación</h3>
                        <p class="case__text">Creación de la identidad visual corporativa para las empresas del Grupo</p>
                    </div>
                    <div class="case__img">
                        <img class="case__img" src="./assets/img/home/success/5-cps.jpg" alt="Branding y Comunicación">
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- contact -->
    <div id="contact" class="home-block__contact">
        <div class="content contact">
            <p>¿Te gustaría comenzar tu nuevo
                <a [routerLink]="['/contacto-proyecto']" class="contact__word contact__word--red">proyecto</a>
                ,
                <a [routerLink]="['/contacto-trabajo']" class="contact__word contact__word--blue">trabajar</a>
                con nosotros o solo quieres decir
                <a [routerLink]="['/contacto-hola']" class="contact__word contact__word--green">hola</a>
                y hablar de tendencias?</p>
        </div>
    </div>
</section>

<app-footer #target></app-footer>
